<mat-form-field class="col-12">
  <mat-label>Fund Family</mat-label>
  <input
    placeholder="Select a Fund Family"
    matInput
    [formControl]="searchControl"
    [matAutocomplete]="familyLookup"
  />
  <mat-icon matSuffix>search</mat-icon>
  <mat-autocomplete
    #familyLookup="matAutocomplete"
    autoActiveFirstOption
    [displayWith]="displayFn"
    (optionSelected)="select($event.option.value)"
  >
    @if (dropdownLoading) {
      <mat-option disabled class="dropdownLoadingSpinner"
        ><mat-spinner diameter="48"
      /></mat-option>
    }
    @if (dropdownNoResults) {
      <mat-option disabled>No Results</mat-option>
    }
    @if (!dropdownLoading && !dropdownNoResults) {
      @for (option of filteredFamilies; track option) {
        <mat-option [value]="option">
          {{ option.Name }}
        </mat-option>
      }
    }
  </mat-autocomplete>
</mat-form-field>
